import {
	Tooltip,
	TooltipContent as TooltipContentPrimitive,
	TooltipTrigger,
} from "@/components/ui/tooltip";
import { TooltipArrow } from "@radix-ui/react-tooltip";

export function TooltipContent({
	children,
	content,
}: { children: React.ReactNode; content?: string }) {
	if (!content) return children;
	return (
		<Tooltip delayDuration={0}>
			<TooltipTrigger asChild>{children}</TooltipTrigger>
			<TooltipContentPrimitive>
				<TooltipArrow className="fill-primary" />
				<p>{content}</p>
			</TooltipContentPrimitive>
		</Tooltip>
	);
}
